module.exports = __webpack_public_path__ + "img/line-tab.cf24854b.svg";